<div class="col-12">
    <!--Table Details Minute by Minute-->
    <app-main-table [tableConfig]="tableConfig"></app-main-table>
</div>
